<template>
  <section id="contact" class="contact">
    <h2>Contact</h2>
    <!-- <p>Send me an email</p> -->
    <div v-if="savingSuccessful" class="form__success">
      Thank you. Your message has been successfully submitted.
    </div>
    <form
      class="contact__form"
      @submit.prevent="sendEmail"
      v-if="!savingSuccessful"
      autocomplete="off"
    >
      <div class="form__item">
        <label
          for="user_name"
          class="form__item__label"
          :class="{ 'input-focused': focus }"
          >Your Name:</label
        >
        <input
          id="user_name"
          type="text"
          name="user_name"
          class="form__item__input"
          required
          @focus="addParentClass"
          @blur="removeParentClass"
        />
      </div>
      <div class="form__item">
        <label
          for="user_email"
          class="form__item__label"
          :class="{ 'input-focused': focus }"
          >Your Email Address:</label
        >
        <input
          id="user_email"
          type="email"
          name="user_email"
          class="form__item__input"
          required
          @focus="addParentClass"
          @blur="removeParentClass"
        />
      </div>
      <div class="form__item">
        <label
          for="message"
          class="form__item__label"
          :class="{ 'input-focused': focus }"
          >Message:</label
        >
        <textarea
          id="message"
          name="message"
          class="form__item__input"
          required
          @focus="addParentClass"
          @blur="removeParentClass"
        ></textarea>
      </div>
      <input class="btn" type="submit" value="Send" />
    </form>
  </section>
</template>

<script>
  import emailjs from "emailjs-com"
  export default {
    name: "Contact",
    data() {
      return {
        savingSuccessful: false,
        isFocusing: false,
        focus: false,
        isBluring: false,
        blur: false,
      }
    },
    methods: {
      addParentClass(event) {
        this.focus = true
        this.find({ ref: "testButton" })
        const button = wrapper.find({ ref: "testButton" })
      },
      removeParentClass(event) {
        this.focus = false
      },

      sendEmail(e) {
        try {
          emailjs.sendForm(
            "service_nd4qr9b",
            "template_gq6ye5q",
            e.target,
            "user_YOPBMHVU9IfQu5XAVRpbF",
            {
              name: this.name,
              email: this.email,
              message: this.message,
            }
          )
        } catch (error) {
          console.log({ error })
        }
        // Reset form field
        this.name = ""
        this.email = ""
        this.message = ""
        // Set success to true to show success message
        this.savingSuccessful = true
      },
    },
  }
</script>

<style lang="scss"></style>
